import React from "react";

import ChatFormBody from "./ChatFormBody";
import ChatFormDescription from "./ChatFormDescription";

const ChatForm = (setModalBody) => {
  return (
    <div className="chat-form-body">
      <ChatFormDescription />
      <ChatFormBody setModalBody={setModalBody} />
    </div>
  );
};

export default ChatForm;
